import UserService from 'Services/user';

export default {
	name: 'screen-monitoring-modal',
	created() {
		this.isLoading = true;
		UserService.getScreenMonitoring()
			.then(response => {
				response.data.tasks.forEach(task => {
					if (task.assigned.all) {
						this.credential.isEnabled = task.arguments.Enabled;
						this.credential.reqPermission = task.arguments.ReqPermission;
						this.$store.commit('UPDATE_SCREEN_MONITORING', task.arguments.Enabled);
					}
				});
			})
			.catch(() => {})
			.finally(() => {
				this.isLoading = false;
			});
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			isLoading: false,
			isSaving: false,
			backed: false,
			credential: {
				isEnabled: false,
				reqPermission: false
			}
		};
	},
	methods: {
		updateScreenMonitoring() {
			this.isSaving = true;
			UserService.setScreenMonitoring(this.credential)
				.then(response => {
					this.$store.commit('UPDATE_SCREEN_MONITORING', this.credential.isEnabled);
					this.back();
				})
				.catch(error => {
					this.errors.add({
						field: 'apierror',
						msg: 'Failed to save settings'
					});
				})
				.finally(() => {
					this.isSaving = false;
				});
		},
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.push('/devices');
			}
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/screen-monitoring-modal/script.js